import React from "react";
import ReactDOM from "react-dom/client";
import { Routes, Route, BrowserRouter as Router, BrowserRouter } from "react-router-dom";

// STYLE LINKS
import "./index.css";
import './config/colors.css';

// CONTEXTS
import { NavigationProvider } from "./contexts/navigationContext";
import { UserAuthProvider } from "./contexts/userAuthContext";

// COMPONENTS
import AppRoutes from "./navigation/appRoutes";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <Router>
      <UserAuthProvider>
        <NavigationProvider>
          <AppRoutes />
        </NavigationProvider>
      </UserAuthProvider>
    </Router>
);
